"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableOverrides = void 0;
var createMuiTableOverrides = function (_a) {
    var palette = _a.palette, shape = _a.shape;
    return ({
        root: {
            backgroundColor: palette.background.paper,
            borderRadius: shape.borderRadius,
        },
    });
};
exports.createMuiTableOverrides = createMuiTableOverrides;
//# sourceMappingURL=MuiTable.js.map